import axiosInstance from '../axiosInterceptor/axiosInstance'
import selectedOrgId from '../../utils/helpers/selectedOrgId'

const getCourt = async (courtId) => {
  const url = `v1/orgs/${selectedOrgId()}/courts/${courtId}`
  const response = await axiosInstance.get(url)
  return response?.data
}
export default getCourt
